export const CRM_PRODUCT_TYPE = "CRM product";
export const MARKETER_PRODUCT_TYPE = "Marketer product";
export const PROJECTS_PRODUCT_TYPE = "Projects product";
export const DEV_PRODUCT_TYPE = "Dev product";
export const WORK_MANAGEMENT_PRODUCT_TYPE = "Work management product";

export const PRODUCT_TYPES = [
  CRM_PRODUCT_TYPE,
  MARKETER_PRODUCT_TYPE,
  PROJECTS_PRODUCT_TYPE,
  DEV_PRODUCT_TYPE,
  WORK_MANAGEMENT_PRODUCT_TYPE
];
